<script setup lang="ts">
import { VaultAssetInstallationEntityType } from '~/codegen/graphql'
import useSkillNavigationContext from '~/composables/use-skill-navigation-context'
import { GetBotForNavigationDocument } from './CurrentLocationBot.generated'

const BOT_GID_PREFIX = 'AG'

const props = defineProps<{
  botIdentifier: string
}>()

const route = useRoute()
const { context: skillNavContext } = useSkillNavigationContext()

const isGid = computed(() => props.botIdentifier.startsWith(BOT_GID_PREFIX))

const { data: botData } = useQuery({
  query: GetBotForNavigationDocument,
  variables: computed(() => (isGid.value ? { id: props.botIdentifier } : { slug: props.botIdentifier })),
})

const bot = computed(() => botData.value?.bot)

function onBotHome() {
  if (route.name?.toString() === 'bots-botSlug') return true
  if (
    skillNavContext.value.entityType === VaultAssetInstallationEntityType.Bot &&
    skillNavContext.value.entityId === props.botIdentifier
  )
    return true
  return false
}
</script>

<template>
  <div v-if="bot" class="flex flex-col pl-2">
    <UButton
      color="white-nav"
      variant="ghost"
      active-class="dark:bg-gray-800 bg-gray-200"
      class="group/navItem relative mb-px flex flex-1 justify-between px-2"
      :class="onBotHome() ? ['bg-blue-80', 'dark:bg-gray-900'] : []"
      @click="navigateTo({ name: 'bots-botSlug', params: { botSlug: bot!.slug } })"
    >
      <div v-if="onBotHome()" class="absolute inset-y-1.5 left-[-5px] w-[3px] rounded-md bg-blue-600" />
      <UTooltip
        :text="bot.name"
        :prevent="bot.name.length < 23"
        :popper="{ placement: 'top', offsetDistance: 14 }"
        :open-delay="500"
        class="flex flex-1 items-center gap-x-2 truncate"
      >
        <UIcon name="light:robot" class="size-4 shrink-0 grow-0 text-gray-500 dark:text-gray-400" />
        <span class="truncate text-left text-nav font-light text-gray-900 dark:text-white">
          {{ bot.name }}
        </span>
      </UTooltip>
    </UButton>
  </div>
</template>
